import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  EntityData,
  EntityListData,
  EntityUpdateRequest,
  Filter,
  PaginatedData, Poi
} from '@models/online-reputation.models';

@Injectable({
  providedIn: 'root'
})
export class LocationsService {

  private readonly http = inject(HttpClient);

  list(filter: Filter): Observable<PaginatedData<EntityListData>> {
    return this.http.post<PaginatedData<EntityListData>>(`api/locations`, filter);
  }

  detail(id: string): Observable<EntityData> {
    return this.http.get<EntityData>(`api/locations/${ id }`);
  }

  updateDetail(id: string, payload: EntityUpdateRequest): Observable<void> {
    return this.http.patch<void>(`api/locations/${ id }`, payload);
  }
}
